import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import setupDataStore from 'agency/digital_renderer/utils/setupDataStore'

import { digObject } from 'functions/utilities'

// eslint-disable-next-line import/no-cycle
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterItems = (items, options) => {
  const { formDataStoreTag } = options || {}

  if (formDataStoreTag){
    return items.filter((item) => {
      const tags = digObject(item, 'data.tags', [])
      return tags.find(tag => tag.title === formDataStoreTag)
    })
  }

  return items
}

const groupItemsByGroupKey = (items) => {
  const grouped = {}

  items.forEach((item) => {
    const { group_key } = item

    if (!grouped[group_key]){
      grouped[group_key] = {
        key: group_key,
        items: [],
      }
    }

    grouped[group_key].items.push(item)
  })

  return Object.values(grouped)
}

const renderItems = (container, groupedItems) => groupedItems.map((group) => {
  const itemContext = {
    dataStore: setupDataStore(group.items),
  }

  return (
    <div key={group.key} style={deviceStyle(container)}>
      <ElementContainer
        forwardContextToItems={itemContext}
        section={container}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const FormResponses = (props) => {
  const { items, options } = props

  const container = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { dataStoreItems } = defaultContext

  const filteredItems = filterItems(dataStoreItems, options)
  const groupedItems = groupItemsByGroupKey(filteredItems)

  return (
    <AnimationWrapper options={options}>
      <div style={style}>{renderItems(container, groupedItems)}</div>
    </AnimationWrapper>
  )
}

FormResponses.propTypes = {
  items: PropTypes.array,
  options: PropTypes.object,
}

FormResponses.defaultProps = {
  items: [],
}

export default FormResponses
